import differenceInCalendarDays from 'date-fns/differenceInCalendarDays'
import humanizeString from 'humanize-string'
import React, { FC } from 'react'

import { SelectBasedField } from '@new/__global/components/Filters/FiltersVariations/Select'

import { FiltersSharedProps } from './Filters.types'

interface Period {
  fromDate: string
  toDate: string
}

interface GranularityFilterProps extends FiltersSharedProps {
  initialValue?: string
  period: Period
  onChange: (value?: string) => void
}

enum Granularity {
  daily = 'DAILY',
  weekly = 'WEEKLY',
  monthly = 'MONTHLY',
  quarterly = 'QUARTERLY',
  yearly = 'YEARLY',
}

const granularityLabel = {
  [Granularity.daily]: 'D',
  [Granularity.monthly]: 'Mo',
  [Granularity.quarterly]: 'Q',
  [Granularity.weekly]: 'We',
  [Granularity.yearly]: 'Y',
}

const granularityDays = {
  [Granularity.daily]: 1,
  [Granularity.weekly]: 8,
  [Granularity.monthly]: 31,
  [Granularity.quarterly]: 91,
  [Granularity.yearly]: 360,
}

const getGranularityOptions = (period: Period) => {
  const differenceInDays = differenceInCalendarDays(new Date(), new Date(period.fromDate))
  const enabledGranularity = Object.values(Granularity).filter(
    granularity => differenceInDays > granularityDays[granularity],
  )

  return enabledGranularity.map(granularity => ({
    label: humanizeString(granularity),
    value: granularity,
    customInputLabel: granularityLabel[granularity],
  }))
}

export const GranularityFilter: FC<GranularityFilterProps> = ({
  label,
  initialValue,
  onChange,
  isSidebarFilter,
  period,
}) => {
  const selectedValue = initialValue
    ? getGranularityOptions(period).find(option => option.value === initialValue)?.value
    : undefined

  return (
    <SelectBasedField
      groupId="chart-granularity-filter"
      title={label || 'Granularity'}
      inputTitle={label}
      options={getGranularityOptions(period)}
      initialValue={selectedValue}
      onChange={onChange}
      isSidebarFilter={isSidebarFilter}
      inputWidth={130}
    />
  )
}
